import {AxiosResponse} from 'axios'
import {unwrapAPIError} from 'utils'
import {EndPoints, HttpMethods} from '../HTTP/HTTP.types'
import {requestHandler} from '../HTTP'

const validateURL = async (data: {
  importURL: string
}): Promise<AxiosResponse<{auth_provider: string; auth_url: string}>> => {
  try {
    const res = await requestHandler<
      {auth_provider: string; auth_url: string},
      typeof data
    >({
      method: HttpMethods.POST,
      url: EndPoints.ValidateURL,
      data,
    })
    return res
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

export const AdminService = {
  validateURL,
}
